<template>
	<div class="qna-block-list">
		<PageHeader />
		<form @submit.prevent="search">
			<ManagingSection :isTable="true">
				<HorizontalSearch
					:blockElem="true"
					@search="search"
					@init="init"
				>
					<SelectInput
						ref="SearchType"
						:defaultSelectValue="searchType"
						:selectList="searchTypeList"
						@change="searchTypeChange"
					/>
					<SelectInput
						ref="Date"
						label="차단일"
						:usePeriod="true"
						@change="dateChange"
					/>
				</HorizontalSearch>
			</ManagingSection>
		</form>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<span class="section__info__left">
					검색 결과 {{ totalCount | number }}건
				</span>
				<div class="section__info__right">
					<button
						:disabled="!itemCheckModel.length"
						class="btn orange section__info__items"
						type="button"
						v-text="'일괄차단해제'"
						@click="deleteBlocks()"
					/>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th class="qna-block-list__list-check-item">
							<input
								v-model="allCheckModel"
								:value="allCheck"
								type="checkbox"
							/>
						</th>
						<th>차단일시</th>
						<th>차단 대상자</th>
						<th>차단 신청자</th>
						<th>관리</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in list" :key="item.id">
						<td>
							<input
								v-model="itemCheckModel"
								:value="item.id"
								type="checkbox"
							/>
						</td>
						<td>{{ item.createdAt | dateFormat }}</td>
						<td>
							<RouterLink
								:to="`/register/register-info/${item.targetRegister.idRegister}`"
								target="_blank"
								class="link"
								v-text="item.targetRegister.nickName"
							/>
						</td>
						<td>
							<RouterLink
								:to="`/register/register-info/${item.reportRegister.idRegister}`"
								target="_blank"
								class="link"
								v-text="item.reportRegister.nickName"
							/>
						</td>
						<td>
							<button
								type="button"
								class="btn orange"
								v-text="'차단해제'"
								@click="deleteBlocks(item)"
							/>
						</td>
					</tr>
				</tbody>
			</table>
			<PaginationBox
				slot="pagination"
				:totalItem="totalCount"
				:limit="limit"
				:offset="offset"
				@to="search($event.offset)"
			/>
		</ManagingSection>
	</div>
</template>
<script>
	import moment from 'moment';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import HorizontalSearch from '@/components/HorizontalSearch.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'QnaRegisterBlock',
		components: {
			PageHeader,
			ManagingSection,
			HorizontalSearch,
			SelectInput,
			PaginationBox,
		},
		data() {
			const searchTypeList = [
				{ value: 'reportRegisterNickName', name: '차단신청자' },
				{ value: 'targetRegisterNickName', name: '차단대상자' },
				{ value: 'reportRegisterId', name: '차단신청자 회원번호' },
				{ value: 'targetRegisterId', name: '차단대상자 회원번호' },
			];

			return {
				searchTypeList,
				searchType: searchTypeList[0].value,
				searchValue: '',
				startCreatedAt: '',
				endCreatedAt: '',
				offset: 0,
				limit: 50,
				list: [],
				totalCount: 0,
				allCheck: false,
				itemCheck: [],
			};
		},
		computed: {
			allCheckModel: {
				get() {
					return this.allCheck;
				},
				set(allCheck) {
					this.allCheck = allCheck;
					this.itemCheck = allCheck
						? this.list.map(item => item.id)
						: [];
				},
			},
			itemCheckModel: {
				get() {
					return this.itemCheck;
				},
				set(itemCheck) {
					this.itemCheck = itemCheck;
					this.allCheck = itemCheck.length === this.list.length;
				},
			},
		},
		methods: {
			setFilter() {
				const query = this.$route.query;

				if (query.offset) this.offset = Number(query.offset);

				if (query.searchType)
					this.$refs.SearchType.selectModel = this.searchType =
						query.searchType;

				if (query.searchValue)
					this.$refs.SearchType.inputModel = this.searchValue =
						query.searchValue;

				if (query.startCreatedAt)
					this.startCreatedAt = Number(query.startCreatedAt);

				if (query.endCreatedAt)
					this.endCreatedAt = Number(query.endCreatedAt);

				this.$refs.Date.changePeriod({
					from: this.startCreatedAt
						? moment(this.startCreatedAt, 'x').format('YYYY-MM-DD')
						: '',
					to: this.endCreatedAt
						? moment(this.endCreatedAt, 'x').format('YYYY-MM-DD')
						: '',
				});
			},
			searchTypeChange({ select, input }) {
				this.searchType = select;
				this.searchValue = input;
			},
			dateChange({ from, to }) {
				this.startCreatedAt = from
					? moment(from, 'YYYY-MM-DD').format('x')
					: '';
				this.endCreatedAt = to
					? moment(to, 'YYYY-MM-DD').endOf('date').format('x')
					: '';
			},
			getListParams() {
				const params = {
					offset: this.offset,
					limit: this.limit,
				};

				if (this.searchValue) {
					params[this.searchType] = this.searchValue;
				}

				if (this.startCreatedAt) {
					params.startCreatedAt = this.startCreatedAt;
				}

				if (this.endCreatedAt) {
					params.endCreatedAt = this.endCreatedAt;
				}

				return params;
			},
			async getList() {
				try {
					const params = this.getListParams();
					const { data } = await this.$axiosAdmin2.get(
						'/api/qna/register/block',
						{ params }
					);
					return data;
				} catch (err) {
					console.error(err);
				}
			},
			async setList() {
				const data = await this.getList();
				this.list = data.qnaRegisterBlockList;
				this.totalCount = data.totalCount;
			},
			setQuery() {
				const query = {};

				if (this.offset) query.offset = String(this.offset);

				if (this.searchType !== this.searchTypeList[0].value)
					query.searchType = this.searchType;

				if (this.searchValue) query.searchValue = this.searchValue;

				if (this.startCreatedAt)
					query.startCreatedAt = String(this.startCreatedAt);

				if (this.endCreatedAt)
					query.endCreatedAt = String(this.endCreatedAt);

				this.$router.replace({ query }).catch(() => {});
			},
			search(offset) {
				this.offset = typeof offset === 'number' ? offset : 0;
				this.setQuery();
				this.setList();
			},
			initFilter() {
				this.searchType = this.searchTypeList[0].value;
				this.searchValue = '';
				this.startCreatedAt = '';
				this.endCreatedAt = '';
				this.$refs.SearchType.init();
				this.$refs.Date.init();
			},
			init() {
				this.initFilter();
				this.search();
			},
			async deleteBlocks(item) {
				try {
					const msg = item
						? `차단대상: ${item.targetRegister.nickName}\n차단신청자: ${item.reportRegister.nickName}\n\n 차단을 해제하시겠습니까?`
						: '선택한 리스트를\n일괄 차단해제 하시겠습니까?';

					if (!confirm(msg)) return;

					const params = {
						idList: item ? [item.id] : this.itemCheck,
					};

					await this.$axiosAdmin2.delete('/api/qna/register/block', {
						data: params,
					});

					this.search();
				} catch (err) {
					console.error(err);
					alert('차단해제에 실패했습니다.');
				}
			},
		},
		mounted() {
			this.setFilter();
			this.setList();
		},
	};
</script>
<style lang="scss" scoped>
	.qna-block-list {
		&__list-check-item {
			width: 44px;
		}
	}
</style>
